import React from 'react';
import { Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { WhitePanelLayout } from '@dom/components';


import { useSelector } from '../../redux';
import { getGuideSearchQuery,  } from '../../redux/selectors';
import { ToolTipRatings } from '../../components';

import {
  getGuideInvoice,
} from '../common';

function SelectGuidePanel({ data, history }) {
  const {
    id,
    name,
    ratings,
    numberOfReviews,
    currency,
    amount,
    livesIn,
  } = data;

  const guideSearchQuery = useSelector(getGuideSearchQuery) || {};
  const { guideQuery: trekName, startDate, endDate, pax, numberOfDays=1 } = guideSearchQuery;
  const total = (amount * numberOfDays).toLocaleString();

  const goToPayment = invoiceId => history.push(`/payment?guideId=${id}&invoiceId=${invoiceId}`);
  const scrollToForm = () => {
    const form = document.getElementById('modify-selection-form');
    form && form.scrollIntoView();
  }

  const handleClick = () => {
    if (!startDate) return scrollToForm();
    getGuideInvoice({
      id,
      trekName: trekName,
      startDate: startDate,
      endDate: endDate,
      pax: Number(pax),
    } , goToPayment);
  }

  return (
    <WhitePanelLayout title="Select Guide">
      <div className="detail-card">
        <div className="card-header">
          <div className="name-rating">
            <h5>{name}</h5>
            <span>
              <ToolTipRatings ratings={ratings} />
              <span> ({numberOfReviews} Review)</span>
            </span>
          </div>
          <div className="total-cost">
          <p className="price">{currency} {total}</p>
          </div>
        </div>
        <div className="card-body">
          <div className="summary">
            <div className="info-box">
            <p><strong>Based In</strong> {livesIn}</p>
            </div>
            <div className="info-box">
              <h6 className="info-title">Price Includes</h6>
              <p>Guide's wages, Food, Accommodation, and Insurance</p>
            </div>
            <div className="info-box">
              <h6 className="info-title">Price Excludes</h6>
              <p>Transportation Cost and Tips</p>
            </div>
          </div>
          <div className="booking-action">
            <div className="other-info">
              <span class="price-per">Price for 1 Day at {currency} {amount}/day</span>
              <div className="info-box">
                <h6 className="info-title">Free Cancellation</h6>
                <p>within 7 Days</p>
                <p className="price">{currency} {total}</p>
              </div>
            </div>
            <Button color="yellow" size="sm" onClick={handleClick}>Request Guide</Button>
          </div>
        </div>
      </div>
    </WhitePanelLayout>       
  );
}

SelectGuidePanel.defaultProps = {
  currency: 'USD',
}

export default withRouter(SelectGuidePanel);
